import { forwardRef, type Ref, type SVGProps } from "react";
const IconErrorOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M18 9.19 17.2 17a1.22 1.22 0 0 1-2.4 0L14 9.19a2 2 0 1 1 4 0" />
    <path d="M16 24a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
    <path
      fillRule="evenodd"
      d="M10.03 3.586A2 2 0 0 1 11.443 3h9.112a2 2 0 0 1 1.415.586l6.443 6.443A2 2 0 0 1 29 11.444v9.112a2 2 0 0 1-.586 1.415l-6.443 6.443a2 2 0 0 1-1.415.586h-9.112a2 2 0 0 1-1.415-.586l-6.443-6.443A2 2 0 0 1 3 20.556v-9.112a2 2 0 0 1 .586-1.415zM11.443 5h9.112L27 11.444v9.112L20.556 27h-9.112L5 20.556v-9.112z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconErrorOutlineSVG);
ForwardRef.displayName = "IconErrorOutline";
export { ForwardRef as IconErrorOutline };
